import React from 'react';
import { Section } from './ui/Section';
export const ComparisonSection = () => {
  const tableData = [{
    sin: 'Te acostás y tu cabeza arranca sola',
    con: 'Te acostás con la cabeza más vacía'
  }, {
    sin: 'Pasás horas dando vueltas en la cama',
    con: 'Sabés exactamente qué hacer cuando no podés bajar'
  }, {
    sin: 'Probás cosas al azar y nada funciona',
    con: 'Tenés un sistema con una lógica clara'
  }, {
    sin: 'Te despertás a las 3 AM y entrás en pánico',
    con: 'Sabés cómo volverte a dormir sin desesperarte'
  }, {
    sin: 'Los pensamientos trampa te destruyen la noche',
    con: 'Tenés respuestas concretas para cada pensamiento'
  }, {
    sin: 'Llegás a la noche siempre pasado de vueltas',
    con: 'Sabés cómo manejar el día para llegar más tranquilo'
  }, {
    sin: 'Te levantás agotado todos los días',
    con: 'Te levantás con más energía y más claridad'
  }, {
    sin: 'Dependés de pastillas o infusiones',
    con: 'Tenés un método propio que funciona desde adentro'
  }];
  return <Section data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-13">
          La diferencia entre seguir igual y tener este sistema
        </h2>

        <div className="overflow-x-auto pb-4 mb-20" data-id="element-14">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-15">
            <thead data-id="element-16">
              <tr data-id="element-17">
                <th className="py-4 px-6 text-red-400 font-bold bg-red-950/30 rounded-tl-lg w-1/2 border-b border-red-900/50" data-id="element-18">
                  SIN el sistema
                </th>
                <th className="py-4 px-6 text-accent-light font-bold bg-accent-blue/10 rounded-tr-lg w-1/2 border-b border-accent-blue/30" data-id="element-19">
                  CON el sistema
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-night-700/50" data-id="element-20">
              {tableData.map((row, idx) => <tr key={idx} data-id="element-21">
                  <td className="py-4 px-6 text-gray-400 bg-red-950/10" data-id="element-22">
                    {row.sin}
                  </td>
                  <td className="py-4 px-6 text-white font-medium bg-accent-blue/5" data-id="element-23">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="h-px w-full bg-night-700 my-16" data-id="element-24" />

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-25">
          <div className="bg-[#2a1a1a] p-8 rounded-2xl border border-red-900/30" data-id="element-26">
            <div className="text-red-400 font-bold tracking-widest uppercase mb-4 text-sm" data-id="element-27">
              ANTES
            </div>
            <p className="text-gray-300 leading-relaxed" data-id="element-28">
              "Son las 2 AM. Llevás una hora en la cama. Tu cabeza repasa todo
              lo del día. El trabajo, la plata, lo que dijiste, lo que tenés que
              hacer mañana. Mirás el celular. Son las 2:17. Hacés la cuenta. Si
              te dormís ahora te quedan 5 horas. Eso te pone peor. El corazón
              late más rápido. Sentís que esto nunca va a terminar."
            </p>
          </div>

          <div className="bg-[#1a2a1a] p-8 rounded-2xl border border-green-900/30" data-id="element-29">
            <div className="text-green-400 font-bold tracking-widest uppercase mb-4 text-sm" data-id="element-30">
              DESPUÉS
            </div>
            <p className="text-gray-200 leading-relaxed" data-id="element-31">
              "Son las 10:30 PM. Hacés tu descarga en el cuaderno. Sacás todo lo
              que tenés en la cabeza. Cerrás el cuaderno. Te acostás. Hacés la
              respiración. Relajás los hombros. Empezás a contar. Tu cabeza
              baja. Baja. Baja. Y te dormís."
            </p>
          </div>
        </div>

        <div className="text-center text-xl text-white font-bold" data-id="element-32">
          Esa es la diferencia. Y está a un paso de distancia.
        </div>
      </div>
    </Section>;
};